export default "__VITE_ASSET__D_Q4s7pz__"